// Re-export all schemas and types for easy importing
export * from './auth.schema'
export * from './course.schema'
export * from './track.schema'
export * from './theme.schema'
export * from './profile.schema'
export * from './kanban.schema'

// Common validation utilities
import { z } from 'zod'

export const PaginationSchema = z.object({
  page: z.number().min(1).default(1),
  limit: z.number().min(1).max(100).default(10),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).default('desc')
})

export const SearchSchema = z.object({
  query: z.string().min(1, 'Termo de busca é obrigatório'),
  category: z.string().optional(),
    tags: z.array(z.string()).optional()
})

export const FilterSchema = z.object({
  category: z.string().optional(),
    tags: z.array(z.string()).optional(),
  status: z.enum(['draft', 'published', 'archived']).optional(),
  dateRange: z.object({
    from: z.date(),
    to: z.date()
  }).optional()
})

// API response schemas
export const ApiResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  data: z.any().optional(),
  error: z.string().optional()
})

export const PaginatedResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    items: z.array(z.any()),
    pagination: z.object({
      page: z.number(),
      limit: z.number(),
      total: z.number(),
      totalPages: z.number(),
      hasNext: z.boolean(),
      hasPrev: z.boolean()
    })
  }),
  message: z.string().optional(),
  error: z.string().optional()
})

// Type exports
export type PaginationData = z.infer<typeof PaginationSchema>
export type SearchData = z.infer<typeof SearchSchema>
export type FilterData = z.infer<typeof FilterSchema>
export type ApiResponse<T = any> = {
  success: boolean
  data?: T
  message?: string
  error?: string
}
export type PaginatedResponse<T = any> = {
  success: boolean
  data: {
    items: T[]
    pagination: {
      page: number
      limit: number
      total: number
      totalPages: number
      hasNext: boolean
      hasPrev: boolean
    }
  }
  message?: string
  error?: string
}